import React, { useEffect, useRef, useState } from 'react';
import SearchableSelect from './SearchableSelect';
import Button from './Button';
import { categoryService } from '../../services/categoryService';
import { tagService } from '../../services/tagService';

const STATUS_OPTIONS = [
   { id: '', name: 'All Status' },
   { id: 'PUBLISHED', name: 'Published' },
   { id: 'DRAFT', name: 'Draft' },
];

const BlogFilters = ({ filters, onChange, onReset }) => {
   const [categories, setCategories] = useState([]);
   const [tags, setTags] = useState([]);
   const [searchText, setSearchText] = useState(filters.search || '');
   const debounceRef = useRef(null);

   useEffect(() => {
      categoryService.getAll().then((res) => setCategories(res.data || []));
      tagService.getAll().then((res) => setTags(res.data || []));
   }, []);

   // Sync searchText if filters.search is cleared externally (e.g. reset)
   useEffect(() => {
      if (!filters.search) setSearchText('');
   }, [filters.search]);

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchText(value);
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
         onChange({ ...filters, search: value });
      }, 400);
   };

   const hasActiveFilters = filters.search || filters.categoryId || filters.tagId || filters.status;

   return (
      <div className="flex flex-wrap gap-3 items-center">
         {/* Search by name */}
         <div className="relative">
            <span className="absolute inset-y-0 left-3 flex items-center text-gray-400 dark:text-gray-500">
               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth={2}
                     d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
                  />
               </svg>
            </span>
            <input
               type="text"
               value={searchText}
               onChange={handleSearchChange}
               placeholder="Search blogs..."
               className="pl-9 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-dark-primary text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-dark-accent focus:border-transparent text-sm w-52"
            />
         </div>

         {/* Status filter */}
         <div className="w-40">
            <SearchableSelect
               searchable={false}
               placeholder="All Status"
               options={STATUS_OPTIONS}
               value={filters.status}
               onChange={(value) => onChange({ ...filters, status: value })}
               className="!mb-0"
            />
         </div>

         {/* Category filter */}
         <div className="w-44">
            <SearchableSelect
               placeholder="All Categories"
               options={[{ id: '', name: 'All Categories' }, ...categories]}
               value={filters.categoryId}
               onChange={(value) => onChange({ ...filters, categoryId: value })}
               className="!mb-0"
            />
         </div>

         {/* Tag filter */}
         <div className="w-40">
            <SearchableSelect
               placeholder="All Tags"
               options={[{ id: '', name: 'All Tags' }, ...tags]}
               value={filters.tagId}
               onChange={(value) => onChange({ ...filters, tagId: value })}
               className="!mb-0"
            />
         </div>

         {hasActiveFilters && (
            <Button variant="secondary" onClick={onReset}>
               Clear Filters
            </Button>
         )}
      </div>
   );
};

export default BlogFilters;
